jQuery.fn.attachDragger = function(){
	let attachment = false, lastPosition, position, difference;
	jQuery( jQuery( this ).selector ).on( 'mousedown mouseup mousemove',function( e ){
		if( 'mousedown' == e.type ) attachment = true, lastPosition = [e.clientX, e.clientY];
		if( 'mouseup' == e.type ) attachment = false;
		if( 'mousemove' == e.type && true == attachment ){
			position = [e.clientX, e.clientY];
			difference = [ ( position[0]-lastPosition[0] ), ( position[1]-lastPosition[1] ) ];
			jQuery( this ).scrollLeft( jQuery( this ).scrollLeft() - difference[0] );
			jQuery( this ).scrollTop( jQuery( this ).scrollTop() - difference[1] );
			lastPosition = [e.clientX, e.clientY];
		}
	} );
	jQuery( window ).on( 'mouseup', function(){
		attachment = false;
	} );
};